import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import StyledBox, {
  StyledCarousel,
  StyledImgBox,
} from 'views/experience-module/MotorcycleTripView/components/MakeCarousel/MakeCarousel.styles';
import { useSelector } from 'react-redux';

const responsive = (itemsLength) => ({
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1300 },
    items: 10,
    partialVisibilityGutter: 0, // this is needed to tell the amount of px that should be visible.
  },
  desktop: {
    breakpoint: { max: 1300, min: 1025 },
    items: 8,
    partialVisibilityGutter: 0,
  },
  tablet: {
    breakpoint: { max: 1025, min: 600 },
    items: 4,
    partialVisibilityGutter: itemsLength <= 4 ? 0 : 20,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 2,
    partialVisibilityGutter: itemsLength <= 2 ? 0 : 40,
    arrow: false,
  },
});
const MakeCarousel = (props) => {
  const { makesRentals, handleVehicleMakeChange } = props;
  const { isCrawler, deviceType } = useSelector((state) => state.globalData);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const [activeItem, setActiveItem] = useState(makesRentals[0].id);

  const handleActiveMakeModelSelect = (id) => {
    setActiveItem(id);
    handleVehicleMakeChange(id);
  };
  return (
    <StyledBox my={3} className="MCContainer">
      <StyledCarousel
        partialVisible={makesRentals.length != 1}
        swipeable
        draggable={false}
        ssr={isCrawler}
        deviceType={deviceType}
        keyBoardControl
        arrows={!isTablet}
        autoPlay={false}
        shouldResetAutoplay={false}
        containerClass="carousel-container"
        customTransition="transform 300ms ease-in"
        responsive={responsive(makesRentals.length)}>
        {makesRentals.map((item) => (
          <Box
            className={`MTSMakeCarouselItem ${
              item.id === activeItem ? 'active' : ''
            }`}
            onClick={() => {
              handleActiveMakeModelSelect(item.id);
            }}
            key={item.id}>
            <StyledImgBox
              imgWidth="80px"
              imgHeight="80px"
              image={{
                src: item.logo_url,
                alt: `${item.name} Motorcycle Rentals`,
              }}
              imgObjectFit="contain"
            />
          </Box>
        ))}
      </StyledCarousel>
    </StyledBox>
  );
};
export { MakeCarousel };
